import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PromoRepository } from '../../../@core/repositories/promo.repository';
import { environment } from '@environments/environment';
import { GetContentDto, GetContentResp } from '../../../@core/usecase/content/get-content.interface';
import { GetCustParamResp } from '../../../@core/usecase/cust-param/get-cust-param.type';
import { PoinListDto, PoinListResp } from '../../../@core/usecase/poin/poin.type';
import { GetClaimVoucherDto, GetClaimVoucherResp } from '../../../@core/usecase/voucher/get-claim-voucher/get-claim-voucher.type';
import { PostValidateHaloNumberDto, PostValidateHaloNumberResp } from '@usecase/voucher/post-validate-halo-number/post-validate-halo-number.type';
import { HttpService } from '@shared/services.http';
import { AdditionalHeader } from '@presentation/pages/landing/landing';

@Injectable({
  providedIn: 'root'
})
export class PromoAdapter extends PromoRepository {
  private readonly httpService = inject(HttpService);

  GetDataContent(params: GetContentDto): Observable<GetContentResp> {
    return this.httpService.get(`${environment.serviceApi}manage-content/promo?targetUrl=${params.data}`, {});
  }

  GetCustParam(header: AdditionalHeader[]): Observable<GetCustParamResp> {
    return this.httpService.get(`${environment.serviceApi}v1/decrypt/custparam`, {}, header);
  }

  GetPoinList(payload: PoinListDto): Observable<PoinListResp> {
    return this.httpService.post(`${environment.serviceApi}manage-content/promo/list-poin`, payload);
  }

  GetClaimVoucher(payload: GetClaimVoucherDto): Observable<GetClaimVoucherResp> {
    return this.httpService.post(`${environment.serviceApi}poins/claim/voucher`, payload);
  }

  PostValidateHaloNumber(payload: PostValidateHaloNumberDto): Observable<PostValidateHaloNumberResp> {
    return this.httpService.post(`${environment.serviceApi}migration/haloplus/info`, payload);
  }
}
